
// src/helpers/context.js

import React from 'react'
import PropTypes from 'prop-types'
import each from 'lodash/each'

export function inject(contextTypes) {
  return (Component)=> {
    class ContextComponent extends React.Component {
      constructor() {
        super()
      }

      render() {
        return <Component {...this.props} {...this.context}/>
      }

      getChildContext() {
        var childContext = {}
        each(contextTypes, (value, key)=> {
          if (typeof this.props[key] == 'function')
            childContext[key] = (...args)=> this.props[key](...args, this.props)
          else
            childContext[key] = this.props[key]
        })
        return childContext
      }
    }

    ContextComponent.childContextTypes = contextTypes
    ContextComponent.displayName = `ContextInject(${Component.displayName})`
    return ContextComponent
  }
}

export default function (contextTypes) {
  return (Component)=> {
    class ContextComponent extends React.Component {
      render() {
        return <Component {...this.props} {...this.context}/>
      }
    }

    ContextComponent.contextTypes = contextTypes
    ContextComponent.displayName = `Context(${Component.displayName})`
    return ContextComponent
  }
}



// WEBPACK FOOTER //
// ./src/helpers/context.js